module.exports = __webpack_public_path__ + "img/71400.360e6a61.jpg";